import { css } from "@compiled/react";

import FeatureGates from "@atlassian/feature-gate-js-client";
import UFOSegment from "@atlassian/wac-ufo-segment";

import { GlobalFooter as GlobalFooterV2 } from "@/patterns/global-footer-v2/src";

import { GlobalFooterBottom } from "./global-footer-bottom";
import { GlobalFooterTop } from "./global-footer-top";

// ==================================================================
// CSS styling
// ==================================================================
const globalFooterStyle = css({
    backgroundColor: "#f4f5f7",
    padding: "32px 0 0 0",
    position: "relative",
    marginInlineEnd: "auto",
    marginInlineStart: "auto",
    minWidth: "100%",
    clear: "both"
});

// ==================================================================
// Type Props
// ==================================================================
export type GlobalFooterPatternProps = {
    selectedLanguage?: string;
    onLanguageChangeHandler?: React.Dispatch<string>;
};

// ==================================================================
// Rendering Functions
// ==================================================================
export const GlobalFooter = ({
    selectedLanguage,
    onLanguageChangeHandler
}: GlobalFooterPatternProps) => {
    const isEnableGlobalFooterV2: boolean = FeatureGates.checkGate(
        "wac-globalui-team24-rollout-footer-gate"
    );

    if (isEnableGlobalFooterV2) {
        return (
            <GlobalFooterV2
                selectedLanguage={selectedLanguage}
                onLanguageChangeHandler={onLanguageChangeHandler}
            />
        );
    } else {
        return (
            <UFOSegment name="global-footer">
                <footer css={globalFooterStyle}>
                    <GlobalFooterTop />
                    <GlobalFooterBottom
                        selectedLanguage={selectedLanguage}
                        onLanguageChangeHandler={onLanguageChangeHandler}
                    />
                </footer>
            </UFOSegment>
        );
    }
};
